import { CancellationToken } from "lib/api/base";

export class StateService {

	public static setCancelableState(
		setState: () => void,
		cancellationToken: CancellationToken
	) {
		if (cancellationToken === undefined || !cancellationToken.isCanceled()) {

			setState();
		}
	}
}
